import { createBreakpoints } from "@chakra-ui/theme-tools";

export const breakpoints = {};
